import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const marketAreaApiKeyStore = {
  createMarketArea: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_MARKET_AREAS`],
    route: `/MarketArea`,
    action: 'POST',
  }),
  updateMarketArea: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_MARKET_AREAS`],
    route: `/MarketArea`,
    action: 'PUT',
  }),
  deleteMareketArea: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_MARKET_AREA`],
    route: `/MarketArea/${id}`,
    action: 'DELETE',
  }),
  getMarketAreas: (): QueryKeyConfig => ({
    queryKey: [`GET_MARKET_AREAS`],
    route: `/MarketArea`,
  }),
  getMarketAreaById: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_MARKET_AREA`, id],
    route: `/MarketArea/${id}`,
  })
};
